import { PageItemApi } from 'api/PageItemApi';
import { LogicModel } from 'api/dto/Logic.dto';
import { PageItemModel } from 'api/dto/PageItem.dto';

export abstract class PageItemAbstractMapper {
  static serialize(model: PageItemModel): PageItemApi.ItemEntry {
    const entry: PageItemApi.ItemEntry = {
      id: model.id,
      position: model.position,
      kind: model.kind,
    };

    if (model.logic) {
      entry.logic = LogicModel.mapLogicModelToDto(model.logic);
    }

    return entry;
  }

  static deserializeShape(entry: PageItemApi.ItemEntry): PageItemModel {
    // we can't deserialize question model, because it's an abstract model

    const model: PageItemModel = {
      id: entry.id,
      position: entry.position,
      kind: entry.kind,
      benchmarkItemId: entry.benchmarkItemId,
      trendItemId: entry.trendItemId,
      locale: entry.locale,
    };

    if (entry.logic) {
      model.logic = LogicModel.mapLogicDtoToModel(entry.logic);
    }

    return model;
  }
}
